export const Login = () => import("./Login.vue");
export const Register = () => import("./Register.vue");
export const PasswordRecovery = () => import("./PasswordRecovery.vue");
